const baseUrl = {
    // basic:'http://47.103.23.31:30011/',
    // basic:'http://222.143.64.39:50012/',
    // basic:'http://192.168.0.159:5001/',
    // basic:'http://222.143.64.39:50012/',
    basic:'http://222.143.64.70:50012/', //正式
    // basic: 'http://awardadminapi.huahansoft.com/' //测试
}

export default baseUrl